export enum ExecutionHistoryAggregateActionTaskState {
  Running = 'running',
  Finished = 'finished',
  Error = 'error',
}

export enum ExecutionHistoryAggregateActionState {
  NotStarted = 'not-started',
  Running = 'running',
  Passed = 'passed',
  Stopped = 'stopped',
  Ignored = 'ignored',
  Error = 'error',
}

export enum ExecutionHistoryEntryState {
  Running = 'running',
  Stopped = 'stopped',
  Finished = 'finished',
  Error = 'error',
}

export enum ConditionTypes {
  SingleChoice = 'single_choice',
  Number = 'number',
  User = 'user',
  Identifier = 'identifier',
  Date = 'date',
  Boolean = 'boolean',
  String = 'string',
}
